import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { PROCESS_STEPS } from '../mock';
import Reveal from './Reveal';

export default function Process() {
  const handleClick = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="come-funziona" className="relative py-24 md:py-32 bg-[#f0ece2]">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <Reveal variant="fade">
          <div className="flex items-start gap-3 mb-10">
            <span className="text-[#1e6cb0] font-bold text-[14px] tracking-[0.18em]">04</span>
            <span className="w-10 h-px mt-3 bg-[#1e6cb0]/60" />
            <span className="text-[12px] tracking-[0.2em] uppercase font-semibold text-neutral-500">
              Il processo
            </span>
          </div>
        </Reveal>

        <div className="grid lg:grid-cols-12 gap-10 mb-16">
          <Reveal as="h2" variant="up" delay={80} className="lg:col-span-7 heading-mega text-[42px] sm:text-[56px] md:text-[72px] text-neutral-900">
            Cinque passi,<br />zero sorprese.<br />
            <span className="text-[#1e6cb0]">Prezzo chiaro</span> dal primo giorno.
          </Reveal>
          <Reveal as="p" variant="up" delay={220} className="lg:col-span-5 text-[16px] leading-relaxed text-neutral-600 lg:mt-6">
            Ogni passo ha un tempo preciso. Sai sempre a che punto siamo e quando ti aspetta
            qualcosa da guardare. Il prezzo te lo diciamo dopo la call, scritto e fermo: niente costi che si gonfiano strada facendo.
          </Reveal>
        </div>

        {/* Timeline */}
        <div className="relative">
          <div className="absolute left-[19px] md:left-[27px] top-3 bottom-3 w-px bg-gradient-to-b from-[#1e6cb0]/40 via-black/10 to-transparent" />
          <ol className="space-y-12 md:space-y-16">
            {PROCESS_STEPS.map((s, i) => (
              <Reveal key={s.n} as="li" variant="up" delay={i * 100} duration={780} className="relative pl-14 md:pl-20">
                <div className="absolute left-0 top-1.5 w-10 md:w-14 h-10 md:h-14 rounded-full bg-white border border-black/10 flex items-center justify-center shadow-sm">
                  <span className="w-3 h-3 rounded-full bg-[#1e6cb0]" />
                </div>
                <div className="grid md:grid-cols-12 gap-6">
                  <div className="md:col-span-3">
                    <div className="heading-mega text-[72px] md:text-[88px] text-neutral-900/10 leading-none">
                      {s.n}
                    </div>
                    <div className="mt-2 text-[12px] tracking-[0.2em] uppercase font-bold text-[#1e6cb0]">
                      {s.time}
                    </div>
                  </div>
                  <div className="md:col-span-9">
                    <h3 className="font-display text-[24px] md:text-[30px] font-bold text-neutral-900">
                      {s.title}
                    </h3>
                    <p className="mt-3 max-w-2xl text-[16px] leading-relaxed text-neutral-600">
                      {s.body}
                    </p>
                  </div>
                </div>
              </Reveal>
            ))}
          </ol>
        </div>

        <Reveal variant="up" delay={150}>
          <div className="mt-20 flex flex-col md:flex-row items-start md:items-center justify-between gap-6 p-8 md:p-10 bg-white rounded-3xl border border-black/5 shadow-[0_20px_60px_-25px_rgba(0,0,0,0.15)]">
            <div>
              <div className="text-[12px] tracking-[0.2em] uppercase font-semibold text-[#1e6cb0]">
                Pronto a partire?
              </div>
              <h3 className="mt-2 heading-mega text-[28px] md:text-[36px] text-neutral-900">
                Il primo passo sono 3 minuti di questionario.
              </h3>
            </div>
            <a
              href="https://wa.me/393383463712?text=Ciao!%20Ho%20visto%20il%20tuo%20sito%20B-WEB%20e%20vorrei%20fare%20il%20primo%20passo."
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-[#1e6cb0] text-white px-7 py-4 rounded-full font-semibold btn-glow whitespace-nowrap"
            >
              Scrivimi su WhatsApp <ArrowUpRight className="w-4 h-4" />
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
